import { QueryClient } from "@tanstack/react-query";

export const ADMIN_LIST_STALE_TIME_MS = 30_000;

export function createAdminQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: ADMIN_LIST_STALE_TIME_MS,
      },
      mutations: {
        retry: false,
        networkMode: "always",
      },
    },
  });
}
